import styled from 'styled-components';

export const EllipsisContainer = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1em;
    max-width: 15rem;
`;
